import axios from "axios";
import { apiUrl } from "../constant";

const PNL_REPORT_BASE = `${apiUrl}/api/reports/pnl`;

export const getPnlMonthlySummaryService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/monthly-summary`, data);
};

export const getPnlRowDetailService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/row-detail`, data);
};

export const backfillPnlService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/admin/backfill`, data);
};
